import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Fieldset from "../../../common/Fieldset";
import Row from "../../../common/Row";
import TextInput from "../../../common/TextInput";
import SelectInput from "../../../common/SelectInput";
import AutoComplete from "../../../common/AutoComplete";
import Col from "../../../common/Col";
import { Landen, RechtspersoonlijkheidTypes, BronTypes } from "../../../../constants/DomainConstants";
import { AUTOCOMPLETE_NO_RESULTS_CIJFERS } from "../../../../constants/ComponentConstants";

const Organisator = (props) => {
    const {
        model,
        getError,
        onChange,
        disabled,
        postcodes,
        gemeenten,
        landen,
        rechtspersoonlijkheidTypes,
        organisatorGegevensUrl,
        hasStep1Status,
        hasFinalStatus,
        validationMessageType
    } = props;

    const isBelgie = model.land === Landen.BELGIE;

    const bronMatches = (bronType) => model.bron === bronType || model.bron === bronType.toString();
    const isOnderneming = bronMatches(BronTypes.MAGDA_ONDERNEMINGEN);
    const isVereniging = bronMatches(BronTypes.MAGDA_VERENIGINGEN);
    const adresTitle = isOnderneming ? "Adres Maatschappelijke zetel" : (isVereniging ? "Correspondentieadres" : undefined);

    return <Fragment>
        <Fieldset title="Organisator">
            <Row>
                <Col>
                    <TextInput
                        name="naam"
                        label="Naam"
                        value={model.naam}
                        onChange={onChange}
                        validationMessage={getError('naam')}
                        validationMessageType={validationMessageType}
                        disabled={disabled || !hasStep1Status || model.naam || hasFinalStatus}
                    />
                </Col>
            </Row>
            <Row>
                <SelectInput
                    size={6}
                    name="rechtspersoonlijkheidId"
                    label="Rechtspersoonlijkheid"
                    value={model.rechtspersoonlijkheidId}
                    onChange={onChange}
                    items={rechtspersoonlijkheidTypes}
                    validationMessage={getError("rechtspersoonlijkheidId")}
                    validationMessageType={validationMessageType}
                    optional
                    disabled={disabled || hasFinalStatus}
                />
                {(model.rechtspersoonlijkheidId !== RechtspersoonlijkheidTypes.ANDERE && model.rechtspersoonlijkheidId !== RechtspersoonlijkheidTypes.ANDERE.toString()) || <TextInput
                    name="andereRechtspersoonlijkheid"
                    label="Andere Rechtspersoonlijkheid"
                    size={6}
                    onChange={onChange}
                    disabled={disabled || hasFinalStatus}
                    value={model.andereRechtspersoonlijkheid}
                    validationMessage={getError('andereRechtspersoonlijkheid')}
                    validationMessageType={validationMessageType} />
                }
            </Row>
        </Fieldset>
        <Fieldset title={adresTitle}>
            {isOnderneming &&
                <Row>
                    <Col size={12}>
                        <p>{"Deze informatie werd opgehaald uit het KBO. Indien deze informatie moet aangepast worden gelieve contact op te nemen met de kruispuntbank van ondernemingen."}</p>
                    </Col>
                </Row>
            }
            {isVereniging &&
                <Row>
                    <Col size={12}>
                        <p>
                            {"Deze informatie werd opgehaald uit het verenigingsregister. Deze informatie kan alleen door de vertegenwoordiger van de vereniging gewijzigd worden op het Verenigingsloket."}
                        </p>
                        <a className="external-link" href="https://www.verenigingsloket.be/nl" target="_blank">
                            {"https://www.verenigingsloket.be/nl "}
                            <i className="fa fa-external-link"></i>
                        </a>
                    </Col>
                </Row>
            }
            <Row>
                <SelectInput
                    size={6}
                    name="land"
                    label="Land"
                    value={model.land}
                    onChange={onChange}
                    items={landen}
                    validationMessage={getError("land")}
                    validationMessageType={validationMessageType}
                    disabled
                    defaultItemVisible
                />
            </Row>
            <Row>
                <TextInput
                    name="straatEnHuisnummer"
                    label="Straat en huisnummer"
                    value={model.straatEnHuisnummer}
                    onChange={onChange}
                    validationMessage={getError('straatEnHuisnummer')}
                    validationMessageType={validationMessageType}
                    disabled
                />
            </Row>
            {
                isBelgie ?
                    <Row>
                        <AutoComplete
                            size={3}
                            label="Postcode"
                            name="postcodeBE"
                            value={model.postcodeBE}
                            onChange={onChange}
                            validationMessage={getError("postcodeBE")}
                            validationMessageType={validationMessageType}
                            items={postcodes}
                            noResultsMessage={AUTOCOMPLETE_NO_RESULTS_CIJFERS}
                            disabled
                        />
                        <AutoComplete
                            size={9}
                            label="Gemeente"
                            name="gemeenteBE"
                            value={model.gemeenteBE}
                            onChange={onChange}
                            validationMessage={getError("gemeenteBE")}
                            validationMessageType={validationMessageType}
                            items={gemeenten}
                            disabled
                        />
                    </Row>
                    :
                    <Row>
                        <TextInput
                            name="postcode"
                            label="Postcode"
                            size={3}
                            onChange={onChange}
                            disabled
                            value={model.postcode}
                            validationMessage={getError('postcode')}
                            validationMessageType={validationMessageType} />
                        <TextInput
                            name="gemeente"
                            label="Gemeente"
                            size={9}
                            onChange={onChange}
                            disabled
                            value={model.gemeente}
                            validationMessage={getError('gemeente')}
                            validationMessageType={validationMessageType} />
                    </Row>
            }
            {model.poid &&
                <Row>
                    <Col size={12}>
                        <a style={{ "color": "#006fb7", "font-weight": "bold", "font-size": ".875rem" }}
                            href={organisatorGegevensUrl + model.poid}
                            target="_blank">
                            <i className="fa fa-external-link"></i>
                            {"   raadpleeg en meld eventuele wijzigingen aan de gegevens van de organisator in de centrale databank van Sport Vlaanderen"}
                        </a>
                        <br />
                        <br />
                    </Col>
                </Row>
            }
        </Fieldset>
    </Fragment>;
};

Organisator.defaultProps = {
    organisatorGegevensUrl: ""
};

Organisator.propTypes = {
    hasStep1Status: PropTypes.bool.isRequired,
    model: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    getError: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    postcodes: PropTypes.array.isRequired,
    gemeenten: PropTypes.array.isRequired,
    landen: PropTypes.array.isRequired,
    rechtspersoonlijkheidTypes: PropTypes.array.isRequired,
    organisatorGegevensUrl: PropTypes.string.isRequired,
    validationMessageType: PropTypes.string,
    hasFinalStatus: PropTypes.bool
};

export default Organisator;